<template>
  <div class="relative">
    <div class="select_box" :class="{'active': active}">
      <div class="main flex align-center" @click="onSelect" :style="{'border-color': active ? '#46b8b0' : '#e2e2e2'}">
        <div class="flex-1 font-12-b9b9b9" v-if="projectMemberStr === '' || projectMemberStr === null">请在该项目的成员内选择</div>
        <div class="flex-1 font-12-30313a" v-else>{{projectMemberStr}}</div>
        <i class="select_img el-icon-arrow-down" :class="{'select_img_rotate' : active}"></i>
      </div>
      <div class="list flex-column" v-if="active">
        <div class="list-main text-left">
          <div class="flex-column" v-for="(item, index) in projectMember" :key="index">
            <div class="bg-f3f4f7 plr-10">{{item.name}}</div>
            <div class="flex align-center item" v-for="(personItem, i) in item.employeeList" :key="i" @click="onCheck(personItem.id, personItem.name)">
              <img :src="isCheck(personItem.id) !== -1 ? '../../static/images/xuanzhong.png' : '../../static/images/weixuan.png'" class="mr-5" alt="">
              <div class="w-68">{{personItem.roleName}}</div>
              <div class="mr-10">{{personItem.name}}</div>
              <div>{{personItem.telephone}}</div>
            </div>
          </div>
        </div>
        <div class="flex align-center justify-center bottom">
          <div class="btn-12-bd-85 mr-5" @click="onReset">重置</div>
          <div class="btn-12-bg-85" @click="onSubmit">确定</div>
        </div>
      </div>
    </div>
    <div class="mask" @click="closeSelect" v-if="active"></div>
  </div>
</template>
<script>
export default {
  name: 'AddPlanOption',
  components: {},
  props: ['id'],
  data () {
    return {
      projectMember: [],
      projectMemberStr: '',
      active: false,
      list: [],
      selectedList: [],
      beforeArr: [],
      beforeStr: ''
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    getProjectMember () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerAssignRecord/getProjectMember`, {
        customerId: this.id
      }).then(res => {
        if (res.data.success) {
          this.projectMember = res.data.data
        }
      })
    },
    onSelect () {
      if (!this.active) {
        this.active = true
        this.getProjectMember()
        this.beforeArr = this.Utils.deepClone(this.selectedList)
        this.beforeStr = this.projectMemberStr
      } else {
        this.active = false
      }
    },
    closeSelect () {
      this.active = false
      this.selectedList = this.Utils.deepClone(this.beforeArr)
      this.projectMemberStr = this.beforeStr
    },
    onCheck (id, name) {
      const that = this
      let item = {
        executorId: id,
        executorName: name
      }
      if (that.isCheck(id) !== -1) {
        this.selectedList.splice(this.isCheck(id), 1)
      } else {
        this.selectedList.push(item)
      }
      let arr = []
      this.selectedList.forEach(i => {
        arr.push(i.executorName)
      })
      this.projectMemberStr = arr.join('、')
    },
    isCheck (id) {
      let index = -1
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].executorId === id) {
          index = i
          break
        }
      }
      return index
    },
    onReset () {
      this.beforeArr = []
      this.selectedList = []
      this.beforeStr = ''
      this.projectMemberStr = ''
    },
    onSubmit () {
      this.$parent.$parent.$parent.$parent.$parent.add.customerPlanExecutorParamList = this.Utils.deepClone(this.selectedList)
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    height: 30px;
    line-height: 30px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #e2e2e2;
    text-align: left;
    padding:  0 10px;
  }
  .mask{
    width: 100vw;
    height:100vh;
    position: fixed;
    top: 0;
    left:0;
    background: transparent;
    z-index: 9;
  }
  .select_box{
    position: relative;
    z-index: 10;
    cursor: pointer;
  }
  .active{
    z-index: 99;
  }
  .select_img{
    transition:transform 0.3s;
  }
  .select_img_rotate{
    transform:rotate(180deg);
  }
  .list{
    background: #fff;
    position: absolute;
    top: 30px;
    left: 0;
    width: 100%;
    border: solid 1px #e2e2e2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    z-index: 11;
  }
  .list-main{
    height: 200px;
    overflow-y: auto;
  }
  .item{
    border-bottom: 1px dashed #e2e2e2;
    padding: 3px 10px;
  }
  .item:last-child{
    border-bottom: none;
  }
  .bottom{
    border-top: 1px solid #e2e2e2;
    padding: 4px 0;
  }
  .w-68{
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/AddPlanOption.vue